import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
declare const animateValue: any;

@Component({
  selector: 'app-rostering',
  templateUrl: './rostering.component.html',
  styleUrls: ['./rostering.component.css']
})
export class RosteringComponent implements OnInit {

  public userData;
  public dashboardData;
  public employeeInfo = ['Jan', 'Feb', 'Mar', 'April', 'May'];
  public employeetData = [
    { data: [65, 59, 80, 81, 56], label: 'Total Employees' }
  ];
  constructor(
    private api: ApiService,
    private router: Router,
    public storage: StorageService,
  ) { 
    setTimeout(()=>{
      this.userData = this.storage.get('userInfo');
    },500)
  }

  ngOnInit(): void {
    setTimeout(()=>{
      this.getDashboardData();
    },500)
  }

  pageNavigate(path, $event) {
    this.router.navigate(['organization/transport-manager/rostering/' + path, {}]);
    // this.router.navigate(['/heroes', { id: heroId }]);
  }
  getDashboardData(){
    const obj = { 
      orgID: this.userData.orgID,
     };

    this.api.transportManagerRosteringDashboard(obj).then((res: any) => {
      if (res.status == 'success') {
        this.dashboardData = res.data;
        this.animateRouteValues();
      }  
      }).catch((err) => {
          console.log(err);
      });
    }
    animateRouteValues(){
      let regularCount = this.dashboardData && this.dashboardData.regularRouteInfo && this.dashboardData.regularRouteInfo.routeCount ? this.dashboardData.regularRouteInfo.routeCount : 0;
      let occassionalCount = this.dashboardData && this.dashboardData.occasionalRouteInfo && this.dashboardData.occasionalRouteInfo.occasionRouteCnt ? this.dashboardData.occasionalRouteInfo.occasionRouteCnt : 0;
      if (regularCount > 0) animateValue('regularRouteCounter', 0, regularCount , 2000);
      else document.getElementById('regularRouteCounter').innerHTML = '0';
      if (occassionalCount > 0) animateValue('ocassionalRouteCounter', 0, occassionalCount, 2000);
      else document.getElementById('ocassionalRouteCounter').innerHTML = '0';
     
    }
}
